/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Noaccounts1Inputs */

const zh_linked_noaccounts1 = /** @type {(inputs: Linked_Noaccounts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无绑定身份`)
};

const en_linked_noaccounts1 = /** @type {(inputs: Linked_Noaccounts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No linked identities`)
};

const es_linked_noaccounts1 = /** @type {(inputs: Linked_Noaccounts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin identidades vinculadas`)
};

/**
* | output |
* | --- |
* | "No linked identities" |
*
* @param {Linked_Noaccounts1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const linked_noaccounts1 = /** @type {((inputs?: Linked_Noaccounts1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Noaccounts1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linked_noaccounts1(inputs)
	if (locale === "en") return en_linked_noaccounts1(inputs)
	return es_linked_noaccounts1(inputs)
});
export { linked_noaccounts1 as "linked_noAccounts" }